var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconsWhiteYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons / White / Youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.43959 7.16344 0.5 16 0.5C24.8366 0.5 32 7.43959 32 16C32 24.5604 24.8366 31.5 16 31.5C7.16344 31.5 0 24.5604 0 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6679 10.6714C23.4022 10.8666 23.9805 11.4418 24.1768 12.1723C24.5335 13.4961 24.5335 16.2583 24.5335 16.2583C24.5335 16.2583 24.5335 19.0204 24.1768 20.3444C23.9805 21.0748 23.4022 21.65 22.6679 21.8453C21.3371 22.2 16.0001 22.2 16.0001 22.2C16.0001 22.2 10.6632 22.2 9.3323 21.8453C8.59795 21.65 8.01962 21.0748 7.82335 20.3444C7.4668 19.0204 7.4668 16.2583 7.4668 16.2583C7.4668 16.2583 7.4668 13.4961 7.82335 12.1723C8.01962 11.4418 8.59795 10.8666 9.3323 10.6714C10.6632 10.3167 16.0001 10.3167 16.0001 10.3167C16.0001 10.3167 21.3371 10.3167 22.6679 10.6714ZM14.4001 13.9333V19.0999L18.6668 16.5167L14.4001 13.9333Z",
    fill: "#759CEA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconsWhiteYoutube);
export default __webpack_public_path__ + "static/media/social-icons-white-youtube.6b5b6f110785cacf95cf6736c9cf3e06.svg";
export { ForwardRef as ReactComponent };